import { BaseEvaluation } from './base-evaluation.entity';
import { Institution } from '../core/institution.entity';
import { Score } from './score.entity';
import { Answer } from './answer.entity';

export enum AutoevaluationStatus {
	open = 0,
	closed = 1,
	pending = 2,
	new = 3,
	no_ended = 4
}

export interface AutoEvaluation {
	id?: string;
	status: AutoevaluationStatus;
	created_at?: Date;
	updated_at?: Date;
	comments: number;
	// Calculed
	average: number;
	progress: number;

	// Relations
	id_institution?: string;
	institution?: Institution;
	baseEvaluation?: BaseEvaluation;
	scores?: Score[];
	answers?: Answer[];
	withEvidences?: number;
	withoutEvidences?: number;
}